import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import axios from 'axios';
import { toast } from 'react-toastify';
import GoogleMap from './GoogleMap';
import * as DateHelpers from './DateHelpers';
import authService from './api-authorization/AuthorizeService';

interface ScheduleDayMap {
    scheduleBranchId: number;
    scheduleDate: any;
    scheduleDateFormatted: string;
    routes: ScheduleRoutes[];
    loading: boolean;
}

interface ScheduleRoutes {
    orderManual: string;
    jobAddresses: JobAddress[]
}

interface JobAddress {
    orderManual: string;
    jobOrder: number;
    placeId: string;
    address: string;
    lat: number;
    lng: number;
}

interface INameToValueMap {
    [key: string]: any;
}

export class ScheduleDayMapData extends React.Component<RouteComponentProps<{}>, ScheduleDayMap> {
    constructor(props: any) {
        super(props);

        this.state = {
            scheduleBranchId: 0,
            scheduleDate: "",
            scheduleDateFormatted: "",
            routes: [],
            loading: true
        };

        
    }

    componentDidMount() {
        let mapParams: INameToValueMap = {};
        mapParams = this.props.match.params;
        let scheduleBranchId = mapParams["scheduleBranchId"];
        let date = mapParams["scheduleDate"];

        this.getScheduleAddresses(scheduleBranchId, date);
    }

    async getScheduleAddresses(scheduleBranchId: number, date: string) {
        const token = await authService.getAccessToken();

        axios.get('api/Schedule/GetScheduleDayJobAddresses?ScheduleBranchId=' + scheduleBranchId + '&ScheduleDate=' + date, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            var dateFormatted = DateHelpers.formatDate(date);
            this.setState({ scheduleBranchId: scheduleBranchId, scheduleDate: date, scheduleDateFormatted: dateFormatted, routes: res.data, loading: false })
        })
        .catch(error => {
            toast.error(error.message);
        });
    }


    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();


        return <div>
            <h1>Jobs scheduled for {this.state.scheduleDateFormatted}</h1>
            {contents}
        </div>;
    }

    renderDetails = () => {

        let map = <GoogleMap routes={this.state.routes} />

        return (
            <div>
                {map}
            </div>
        );

    }

};

